import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import EntranceExitItem from '@blade-sxp/task-management/components/entrance-exit/item.vue';
let EntranceExit = class EntranceExit extends Vue {
    devices;
    entranceExitData;
    disabled;
};
__decorate([
    Prop()
], EntranceExit.prototype, "devices", void 0);
__decorate([
    Prop()
], EntranceExit.prototype, "entranceExitData", void 0);
__decorate([
    Prop({ default: false, type: Boolean })
], EntranceExit.prototype, "disabled", void 0);
EntranceExit = __decorate([
    Component({
        name: 'entranceExit',
        components: { EntranceExitItem },
        i18n: {
            messages: {
                en: {
                    device: 'Device',
                },
                zh: {
                    device: '设备',
                },
            },
        },
    })
], EntranceExit);
export default EntranceExit;
